import { computed, defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { MemberUi } from '@/fairplayer/primary/members-page/Member.ui';

export default defineComponent({
  name: 'BidderIdentity',

  props: {
    bidder: {
      type: Object as PropType<MemberUi>,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const YOU = t('marketplace.auction.yourIdentity');
    const ANONYMOUS = t('marketplace.auction.anonymousIdentity');

    const knownIdentity = () => `${props.bidder.firstName} ${props.bidder.lastName}`;

    const bidderIdentity = computed(() => {
      if (props.bidder.me) {
        return YOU;
      }

      if (props.bidder.anonymous) {
        return ANONYMOUS;
      }

      return knownIdentity();
    });

    return {
      t,
      bidderIdentity,
    };
  },
});
